import { type MCPServerInfo } from '../../types';

const BrazeServer: MCPServerInfo = {
  serverId: 'BRAZE',
  name: 'Braze',
  slug: 'braze',
  description:
    'Customer engagement and cross-channel marketing platform. Provides programmatic access to the Braze REST API for inspecting campaigns, segments, and user data.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    // Sentinel image-style ref: the build script (operations/bin/build-mcp-images.sh)
    // uses this shape to skip the git clone path. The actual package is fetched
    // from PyPI by Dockerfile.generated via `pip install braze-mcp-server`. The
    // upstream homepage is https://pypi.org/project/braze-mcp-server/.
    repositoryUrl: 'mcp/braze-mcp-server:latest',
    commitSha: 'latest',
    packageType: 'pip',
    packageName: 'braze-mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['brazeApiKey', 'brazeBaseUrl'],
    properties: {
      brazeApiKey: {
        type: 'string',
        description:
          'Braze REST API key. Create a dedicated MCP-purpose key in Braze Dashboard → Settings → APIs and Identifiers → API Keys with read-only, non-PII permissions.',
        sensitive: true
      },
      brazeBaseUrl: {
        type: 'string',
        description:
          'Braze REST endpoint for your instance (e.g. https://rest.iad-01.braze.com). Varies by region (US-01..US-10, EU clusters). Find it in Braze Dashboard → Settings → APIs and Identifiers → REST endpoint.',
        sensitive: false
      }
    }
  }
};

export default BrazeServer;
